import { translate } from 'i18n/i18n'
import React from 'react'
import type { TIrrigationActivityForPointOrZone } from '../../../caches/StationValuesCache/StationValuesCache'
import { formatEmitterData } from '../_utils/formatEmitterData'
import { formatEmitterPressureData } from '../_utils/formatEmitterPressureData'

export const IrrigationActivityTooltip = ({
  emitters,
  valueTypeIsForStatus,
  valueTypeIsForPressure = false,
}: {
  emitters: TIrrigationActivityForPointOrZone
  valueTypeIsForStatus: boolean
  valueTypeIsForPressure?: boolean
}) => {
  const emitterData = Object.entries(emitters).map((entry) =>
    valueTypeIsForPressure
      ? formatEmitterPressureData(entry)
      : formatEmitterData(entry, valueTypeIsForStatus),
  )

  return (
    <div
      css={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        fontSize: 14,
        padding: 10,
        borderRadius: 8,
      }}
    >
      <div
        css={{
          gap: 12,
          display: 'grid',
          gridTemplateColumns: valueTypeIsForPressure ? 'minmax(0, 1fr) auto auto' : '2.5fr 1fr 1.5fr',
          width: '100%',
        }}
      >
        {emitterData.length === 0 ? (
          <div
            css={{
              gridColumn: '1 / span 3',
              textAlign: 'center',
              padding: 10,
              fontStyle: 'italic',
            }}
          >
            {translate.phrases.banyanApp('No irrigation data available')}
          </div>
        ) : (
          emitterData.map((row) => (
            <React.Fragment key={row.id}>
              <div
                css={{
                  display: 'flex',
                  alignItems: 'center',
                  minWidth: 0,
                }}
              >
                {row.emitter}
              </div>
              <div
                css={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minWidth: 0,
                }}
              >
                {row.duration}
              </div>
              <div
                css={{
                  display: 'flex',
                  alignItems: 'center',
                  minWidth: 0,
                }}
              >
                {row.applied}
              </div>
            </React.Fragment>
          ))
        )}
      </div>
    </div>
  )
}
